<template>
  <div class="letter_body">
    <head-top head-title="承诺书" go-back="true"></head-top>
    <div class="letter_content">
      <h4>现在我向全体业主郑重做出如下承诺：</h4>
      <!--业委会选举承诺书-->
      <ul v-show="pageType === '1' || pageType==='5'">
        <li>1、本人以及近亲属与本小区建设单位和物业服务企业无任何利害关系。</li>
        <li>2、热心公益事业，有较充裕的时间，认真履行好业主委员会委员职责。</li>
        <li>3、本人提交的简历、房地产权证、身份证和有关资历证明完全属实。</li>
        <li>4、严格遵守法律、规章和《物业管理条例》相关规定，严格遵守业主委员会选举
          办法的各项规定。自愿接收参选资格条件的审核，若不符合选举办法参选规定的，自动退出竞选，若当选，接受当选无效的决定。
        </li>
        <li>5、自觉接受居民委员会和全体业主的监督，真诚表达竞选愿望和决心，公开平等参加选举。</li>
        <li>6、自愿接受全体业主的监督，依法、公开、透明、自觉按照法定程序参与竞选，无论结果如何，
          都能正确认识、配合新一届业主委员会开展工作。
        </li>
        <li><span>以上承诺，完全属实，否则将依法承担一切责任</span></li>
      </ul>
      <!--其他承诺书-->
      <ul v-show="pageType==='2' || pageType==='3' || pageType==='4' || pageType==='6'">
        <li>1、具有完全民事行为能力。</li>
        <li>2、遵守国家有关法律、法规。</li>
        <li>3、遵守临时管理规约和业主大会议事规则，模范履行业主义务。</li>
        <li>4、热心公益事业，责任心强，公正廉洁，具有较强的社会公信力。</li>
        <li>5、具有一定的组织协调能力。</li>
        <li>6、具备必要的工作时间。</li>
      </ul>
      <button @click="goRegister">已阅读并且同意</button>
    </div>
  </div>
</template>

<script>
  import headTop from '../header/Header'

  export default {
    name: 'Letter',
    data() {
      return {
        pageType: '', // 报名的类型
        id: '', // 列表id
        title: '' // 列表名称
      }
    },
    created() {
      // type 1:业委会候选人报名   2：筹备组报名  3：换届工作组报名  4：改选工作组报名
      // console.log(this.$route.params.type)
      this.pageType = this.$route.params.type
      this.id = this.$route.params.id
      this.title = this.$route.params.title
      // console.log(this.pageType)
    },
    methods: {
      goRegister() {
        // console.log(this.pageType)
        if (this.pageType === '1') {
          this.$router.push('/home/CandRegist/' + this.id + '/' + this.title) // 业委会候选人
        }
        if (this.pageType === '2') {
          this.$router.push('/home/PrepareRegist/' + this.id + '/' + this.title) // 筹备组
        }
        if (this.pageType === '3') {
          this.$router.push('/home/ChangeRegist/' + this.id + '/' + this.title) // 换届工作组
        }
        if (this.pageType === '4') {
          this.$router.push('/home/RelectRegist/' + this.id + '/' + this.title) // 改选工作组
        }
        if (this.pageType === '5') {
          this.$router.push('/home/SuperRegist/' + this.id + '/' + this.title) // 监督委员会
        }
        if (this.pageType === '6') {
          this.$router.push('/home/OtherRegist/' + this.id + '/' + this.title) // 其他报名
        }
      }
    },
    components: {
      headTop
    }
  }
</script>

<style lang="scss" scoped>
  .letter_body {
    padding-top: 40px;
    .letter_content {
      padding: 10px;
      h4 {
        font-size: 16px;
        color: #292929;
        font-weight: normal;
        padding: 10px 0 20px 0;
      }
      ul {
        li {
          font-size: 15px;
          color: #545454;
          padding: 3px 0;
          line-height: 26px;
        }
      }
      button {
        margin-top: 10px;
        width: 100%;
        background: #2585d0;
        color: #ffffff;
        font-size: 15px;
        outline: none;
        border: none;
        padding: 10px 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/Letter.vue